import { Extension } from '@tiptap/core'
import { Plugin } from '@tiptap/pm/state'
import { findPlaceholderMatches } from './not-specified-mark'

/**
 * Applies notSpecified mark after any transaction that leaves placeholder text
 * without the mark. Ensures plain and extended `[NOT_FOUND: Field Name]` forms
 * (and legacy tokens) are highlighted even when setContent runs in a way that
 * runs in a way that doesn't allow a follow-up call.
 */
export const NotSpecifiedPlugin = Extension.create({
  name: 'notSpecifiedPlugin',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        appendTransaction(_transactions, _oldState, newState) {
          const { schema, tr: transaction } = newState
          const markType = schema.marks.notSpecified
          if (!markType) {
            return null
          }

          const { doc } = newState
          let modified = false

          doc.descendants((node, pos) => {
            if (!node.isText || !node.text) {
              return
            }

            const matches = findPlaceholderMatches(node.text)

            for (const pm of matches) {
              const from = pos + pm.index
              const to = from + pm.length
              if (!newState.doc.rangeHasMark(from, to, markType)) {
                transaction.addMark(
                  from,
                  to,
                  markType.create({
                    placeholder: pm.placeholder,
                    fieldLabel: pm.fieldLabel,
                    guidance: pm.guidance,
                  })
                )
                modified = true
              }
            }
          })

          return modified ? transaction : null
        },
      }),
    ]
  },
})
